export function generateUrl(
  template: string,
  params: Record<string, string | number>
): string {
  return Object.entries(params).reduce(
    (url, [key, value]) => url.replace(`:${key}`, value.toString()),
    template
  );
}
